"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarGridCellElement = exports.CalendarGridRowElement = exports.CalendarGridElement = void 0;

var _styled = _interopRequireDefault(require("../../../../styled"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarGridElement = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

exports.CalendarGridElement = CalendarGridElement;

var CalendarGridRowElement = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin: 0.125rem 0;\n"])));

exports.CalendarGridRowElement = CalendarGridRowElement;

var CalendarGridCellElement = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));

exports.CalendarGridCellElement = CalendarGridCellElement;